import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumYesNoEither implements BaseEnumType {
  private static allValues: EnumYesNoEither[] = []; // make sure this is top-most
  
  public static either = new EnumYesNoEither(0, "Either", "enum_yes_no_either_either");
  public static yes = new EnumYesNoEither(1, "Yes", "enum_yes_no_either_yes");
  public static no = new EnumYesNoEither(2, "No", "enum_yes_no_either_no");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumYesNoEither.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isEither() { return this === EnumYesNoEither.either; }
  public isYes() { return this === EnumYesNoEither.yes; }
  public isNo() { return this === EnumYesNoEither.no; }

  public static getValues(): readonly EnumYesNoEither[] {
    return EnumYesNoEither.allValues;
  }

  public static getValuesExcept0(): readonly EnumYesNoEither[] {
    return EnumYesNoEither.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumYesNoEither {
    const found = EnumYesNoEither.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumYesNoEither - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumYesNoEither): EnumYesNoEither {
    const found = name ? EnumYesNoEither.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumYesNoEither - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumYesNoEither>): boolean {
    return this.key === other?.key;
  }
}